import {CTA, styled, Text} from '@volkswagen-onehub/components-core';
import React, {useContext} from 'react';
import {Unit} from '../../types/enums/unit.enum';
import {LengthUnitContext} from '../../context/modules/dimensions/LengthUnitContext';
import useTrans from '../../hooks/use-trans';

const LengthToggleContainer = styled.div`
  display: flex;
  column-gap: ${(props) => props.theme.size.dynamic0020};
  align-items: baseline;

  span {
    text-decoration: none;
  }

  div,
  button:first-child {
    display: inline-block;

    span::after {
        content: '';
        display: inline-block;
        width: 1px;
        height: 18px;
        background-color: black;
        vertical-align: middle;
        margin-left: 6px;
        margin-right: 2px;
      }
    }
`;

const LengthToggle = () => {
  const {
    sections: {
      dimensions: {toggle},
    },
    aria: {
      length: {
        toggle: toggleAria
      }
    }
  } = useTrans();

  const unitCtx = useContext(LengthUnitContext);

  const onSetUnit = (unit: Unit) => {
    unitCtx?.set(unit);

    const announcement = document.getElementById('length-toggle-announcement');

    if(announcement) {
      announcement.textContent = unit + ' selected';
    }
  };

  return (
    <LengthToggleContainer>
      {Object.entries(Unit).map(([key, value]) => {
        const label = toggle[value];
        const aria = toggleAria[value];
        return (
          <CTA
            emphasis="tertiary"
            tag="button"
            key={'cta' + key + '-' + value}
            onClick={() => onSetUnit(value)}
            aria-label={aria}
            aria-pressed={unitCtx?.unit === value}
          >
            <Text bold={unitCtx?.unit === value}>{label}</Text>
          </CTA>
        );
      })}
    </LengthToggleContainer>
  );
};

export default LengthToggle;
